import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { ThumbsUp, ThumbsDown, AlertCircle, XCircle } from 'lucide-react';
import React from 'react';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const getStatusDisplay = (status: string | boolean | undefined) => {
  const normalizedStatus = typeof status === 'boolean' ? (status ? 'TRUE' : 'FALSE') : (status || '').toUpperCase();

  switch (normalizedStatus) {
    case 'TRUE':
      return {
        label: 'Accepted',
        icon: React.createElement(ThumbsUp, { className: 'h-4 w-4 text-green-500' }),
        colorClass: 'text-green-500',
        bgColorClass: 'bg-green-100',
      };
    case 'FALSE':
      return {
        label: 'Rejected',
        icon: React.createElement(ThumbsDown, { className: 'h-4 w-4 text-red-500' }),
        colorClass: 'text-red-500',
        bgColorClass: 'bg-red-100',
      };
    case 'EX':
      return {
        label: 'Exclamation',
        icon: React.createElement(AlertCircle, { className: 'h-4 w-4 text-yellow-500' }),
        colorClass: 'text-yellow-500',
        bgColorClass: 'bg-yellow-100',
      };
    case 'CROSS':
      return {
        label: 'Cross',
        icon: React.createElement(XCircle, { className: 'h-4 w-4 text-red-500' }),
        colorClass: 'text-red-500',
        bgColorClass: 'bg-red-100',
      };
    case 'NULL':
      return {
        label: 'N/A',
        icon: null,
        colorClass: 'text-gray-500',
        bgColorClass: 'bg-gray-100',
      };
    default:
      return {
        label: 'N/A',
        icon: null,
        colorClass: 'text-gray-500',
        bgColorClass: 'bg-gray-100',
      };
  }
};

// Options for the MultiSelect filter, using simple string labels
export const statusFilterDisplayOptions = [
  { value: 'TRUE', label: 'Accepted' },
  { value: 'FALSE', label: 'Rejected' },
  { value: 'EX', label: 'Exclamation' },
  { value: 'CROSS', label: 'Cross' },
  { value: 'NULL', label: 'N/A' },
];

// Utility function to handle file downloads
export const downloadFile = (url: string, fileName?: string): boolean => {
  try {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || url.split('/').pop() || 'download';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
  } catch (error) {
    console.warn('Automatic download failed, opening in new tab:', error);
    window.open(url, '_blank');
    return false;
  }
}; 